import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '../controls/Button';
import Typography from '@material-ui/core/Typography';

const styles = (theme) => ({
    deleteButton: {
        backgroundColor: '#FF0000',
        color: '#FFFFFF',
        '&:hover': {
            backgroundColor: '#D32F2F',
        },
    },
    actionButtons: {
        padding: theme.spacing(3),
    },
});

class DeleteDialog extends React.Component {
    render() {
        return (
            <Dialog open={this.props.open} fullWidth>
                <form>
                    <DialogTitle>{'Are you sure you want to delete?'}</DialogTitle>
                    <DialogContent>
                        <Typography variant="body1" inline={'true'}>
                            This field is referenced by other field rules. Deleting the field may affect the rules of
                            those fields.
                        </Typography>
                    </DialogContent>
                    <DialogActions className={this.props.classes.actionButtons}>
                        <Button onClick={this.props.handleDeleteDialogClose}>Cancel</Button>
                        <Button
                            className={this.props.classes.deleteButton}
                            onClick={this.props.handleDeleteFieldFromDialog}
                            type="button"
                        >
                            Delete
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        );
    }
}

export default withStyles(styles)(DeleteDialog);
